'use strict';

var CurrencyCode = /* @__PURE__ */ ((CurrencyCode2) => {
  CurrencyCode2["Krw"] = "KRW";
  CurrencyCode2["Usd"] = "USD";
  CurrencyCode2["Jpy"] = "JPY";
  return CurrencyCode2;
})(CurrencyCode || {});
var CurrencySymbol = /* @__PURE__ */ ((CurrencySymbol2) => {
  CurrencySymbol2["Krw"] = "\u20A9";
  CurrencySymbol2["Usd"] = "$";
  CurrencySymbol2["Jpy"] = "\xA5";
  return CurrencySymbol2;
})(CurrencySymbol || {});

exports.CurrencyCode = CurrencyCode;
exports.CurrencySymbol = CurrencySymbol;
//# sourceMappingURL=currency.cjs.map
